import { request } from './dashboardApi';

const itemService = {
  // GET items
  getAllItems: async () => {
    try {
      const response = await request('?path=items');
      return response.data || [];
    } catch (error) {
      console.error('Error getting items:', error);
      return [];
    }
  },

  // Internal helper to upload photo matching mobile logic
  uploadPhoto: async (imageFile) => {
    try {
      const formData = new FormData();
      formData.append('photo', imageFile);
      
      const response = await request('?path=items/upload-photo', {
        method: 'POST',
        body: formData
      });

      if (response && (response.success === true || response.status === 'success') && response.data?.url) {
        return response.data.url;
      }
      return null;
    } catch (error) {
      console.error('Photo upload failed:', error);
      return null;
    }
  },

  // Create Item (Matches mobile pattern: upload photo first, then save JSON)
  createItem: async (itemData) => {
    try {
      let photoUrl = null;
      if (itemData.image_file) {
        photoUrl = await itemService.uploadPhoto(itemData.image_file);
        if (!photoUrl) throw new Error('Failed to upload photo');
      }

      const asOfDate = itemData.as_of_date || new Date().toISOString().split('T')[0];
      const isPublicVal = (itemData.is_public === false || itemData.is_public === 0 || itemData.is_public === '0') ? 0 : 1;
      const defaultCategory = itemData.item_type === 'service' ? 'GeneralService' : 'General';

      const body = JSON.stringify({
        name: itemData.name,
        item_type: itemData.item_type,
        unit: itemData.unit,
        sale_price: parseFloat(itemData.sale_price || 0),
        discount_price: parseFloat(itemData.discount_price || 0),
        purchase_price: parseFloat(itemData.purchase_price || 0),
        tax_included: itemData.tax_included ? 1 : 0,
        is_public: isPublicVal,
        category: itemData.category || defaultCategory,
        description: itemData.description || '',
        hsn_sac_code: itemData.hsn_sac_code || '',
        gst_rate: itemData.gst_rate || '',
        opening_stock: parseFloat(itemData.opening_stock || 0),
        low_stock_alert: parseFloat(itemData.low_stock_alert || 0),
        as_of_date: asOfDate,
        photo_url: photoUrl
      });

      const response = await request('?path=items', {
        method: 'POST',
        body: body
      });

      return response && (response.success === true || response.status === 'success');
    } catch (error) {
      console.error('Create item failed:', error);
      return { success: false, message: error.message };
    }
  },

  // Update Item (Matches mobile pattern: upload photo first, then save JSON)
  updateItem: async (itemId, itemData) => {
    try {
      let photoUrl = itemData.photo_url || null;
      if (itemData.image_file) {
        photoUrl = await itemService.uploadPhoto(itemData.image_file);
        if (!photoUrl) throw new Error('Failed to upload photo');
      }

      const asOfDate = itemData.as_of_date || new Date().toISOString().split('T')[0];
      const isPublicVal = (itemData.is_public === false || itemData.is_public === 0 || itemData.is_public === '0') ? 0 : 1;
      const defaultCategory = itemData.item_type === 'service' ? 'GeneralService' : 'General';

      const body = JSON.stringify({
        name: itemData.name,
        item_type: itemData.item_type,
        unit: itemData.unit,
        sale_price: parseFloat(itemData.sale_price || 0),
        discount_price: parseFloat(itemData.discount_price || 0),
        purchase_price: parseFloat(itemData.purchase_price || 0),
        tax_included: itemData.tax_included ? 1 : 0,
        is_public: isPublicVal,
        category: itemData.category || defaultCategory,
        description: itemData.description || '',
        hsn_sac_code: itemData.hsn_sac_code || '',
        gst_rate: itemData.gst_rate || '',
        opening_stock: parseFloat(itemData.opening_stock || 0),
        low_stock_alert: parseFloat(itemData.low_stock_alert || 0),
        as_of_date: asOfDate,
        photo_url: photoUrl
      });

      const response = await request(`?path=items/${itemId}`, {
        method: 'PUT',
        body: body
      });

      return response && (response.success === true || response.status === 'success');
    } catch (error) {
      console.error('Update item failed:', error);
      return { success: false, message: error.message };
    }
  },

  // DELETE Item
  deleteItem: async (itemId) => {
    try {
      const response = await request(`?path=items/${itemId}`, {
        method: 'DELETE'
      });
      return response && (response.success === true || response.status === 'success' || response.data === true);
    } catch (error) {
      console.error('Delete item failed:', error);
      return false;
    }
  }
};

export default itemService;
